import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    AUDIO_GET_ALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'AUDIO_GET_ALL_SUCCEEDED',
  'AUDIO_GET_ALL_FAILED',

  'AUDIO_SELECT',
  'AUDIO_RESET',

  'AUDIO_SHOW_MODAL',
  'AUDIO_HIDE_MODAL',
);
